import ItineraryTranslationsLayout from './Layout'

export default [
  {
    path: 'itinerary-translations',
    component: ItineraryTranslationsLayout,
    name: 'ItineraryTranslations',
    meta: {
      breadcrumb: 'Trad. Itinerarios'
    }
  }
]
